/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".select-plan-modal-container{width:1200px}.select-plan-modal-container .mat-dialog-container{background-color:#fafafa}select-plan-modal{display:block}select-plan-modal .mat-stepper-horizontal{background-color:inherit;margin:0 50px}select-plan-modal select-plan-panel,select-plan-modal select-plan-period-panel{padding:20px 0 5px}"];
export { styles as styles };
